import { gql } from 'apollo-boost'

export const CREATE_ONE_MESSAGE_POINT = gql`
  mutation createOneMessagePoint($data: InputPutCreateOneMessagePoint) {
    createOneMessagePoint(data: $data)
  }
`

